import { StaticProvider } from '@angular/core';

import { WidgetType } from '@frontend/sports/types/components/widget';
import { WIDGET_SKELETON } from '@frontend/sports/widget/core/feature';
import { of } from 'rxjs';

import { MarqueeWidgetSkeletonComponent } from './marquee-widget-skeleton.component';

export function provideMarqueeWidgetSkeleton(): StaticProvider {
    return {
        provide: WIDGET_SKELETON,
        useValue: {
            type: WidgetType.Marquee,
            component: MarqueeWidgetSkeletonComponent,
            config: () => {
                return of({ visible: true });
            },
        },
        multi: true,
    };
}
